import request from '@/api/request'
// 添加FAQ
export const addFAQ = (data) => {
  return request({
    url: '/v1/manager/faq/add',
    method: 'post',
    data: data
  })
}
// 删除FAQ
export const deleteFAQ = (data) => {
  return request({
    url: '/v1/manager/faq/delete',
    method: 'post',
    data: data
  })
}
// 更新FAQ
export const updateFAQ = (data) => {
  return request({
    url: '/v1/manager/faq/update',
    method: 'post',
    data: data
  })
}
// 获取FAQ
export const getFAQList = (data) => {
  return request({
    url: '/v1/manager/faq/list',
    method: 'post',
    data: data
  })
}
// 获取单个FAQ列表
export const getFAQById = (data) => {
  return request({
    url: '/v1/manager/faq/get',
    method: 'post',
    data: data
  })
}
// 置顶
export const saveTopEvent = (data) => {
  return request({
    url: '/v1/manager/faq/saveTop',
    method: 'post',
    data: data
  })
}
